import { render, staticRenderFns } from "./ratings_sub_display.vue?vue&type=template&id=7604970a&scoped=true&"
import script from "./ratings_sub_display.vue?vue&type=script&lang=js&"
export * from "./ratings_sub_display.vue?vue&type=script&lang=js&"
import style0 from "./ratings_sub_display.vue?vue&type=style&index=0&id=7604970a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7604970a",
  null
  
)

export default component.exports